/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getPopularFeedGenerators.defs.js'
export { main as default } from './getPopularFeedGenerators.defs.js'
